import { PackageGroupClient } from "./packageGroup";

export class GroupClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/groups`;

    this.packageGroups = new PackageGroupClient(this.httpClient, this.baseURL);
  }
}



// WEBPACK FOOTER //
// ./src/clients/BaanRueJaiClient/group/index.js